import { domHelpers } from '@approvalmax/utils';
import { FC } from 'react';

import { useContactListItemQa } from './ContactListItem.hooks';
import { ContactListItemContactEmail, ContactListItemContactName, ContactListItemWrap } from './ContactListItem.styles';
import { ContactListItemProps } from './ContactListItem.types';

const ContactListItem: FC<ContactListItemProps> = (props) => {
    const { item: contact, active, highlightedText, rootRef, onSelect, onHover, integrationType } = props;

    const handleSelect = () => {
        onSelect(contact);
    };

    const handleHover = () => {
        onHover(contact);
    };

    const { qaWrap } = useContactListItemQa(integrationType);

    return (
        <ContactListItemWrap
            isActive={active}
            onClick={handleSelect}
            data-qa={qaWrap()}
            data-qa-id={contact.id}
            data-qa-name={contact.emailAddress}
            onMouseEnter={handleHover}
            ref={rootRef}
        >
            {highlightedText ? (
                <ContactListItemContactName
                    dangerouslySetInnerHTML={{
                        __html: domHelpers.highlightText(contact.text, highlightedText, true, 'highlighted-text'),
                    }}
                />
            ) : (
                <ContactListItemContactName>{contact.text}</ContactListItemContactName>
            )}

            {highlightedText ? (
                <ContactListItemContactEmail
                    dangerouslySetInnerHTML={{
                        __html: domHelpers.highlightText(
                            contact.emailAddress,
                            highlightedText,
                            true,
                            'highlighted-text'
                        ),
                    }}
                />
            ) : (
                <ContactListItemContactEmail>{contact.emailAddress}</ContactListItemContactEmail>
            )}
        </ContactListItemWrap>
    );
};

export default ContactListItem;
